import { connect } from 'react-redux';
import { get } from 'lodash';
import { isUserLoggedIn } from 'apps/user/helpers';
import getAnalyticsData from '../utils/getAnalyticsData';

import BasketControls from '../components/partials/BasketControls';

export default connect(
  (state, ownProps) => {
    const { hideControls, product, sku } = ownProps;

    const basketItem = state.basket.items.find(item => item.sku === sku);
    const analyticsContextData = {
      basket: state.basket,
      basketItems: state.basket.items,
      ...ownProps.analyticsContextData,
      ...getAnalyticsData(product),
    };

    return {
      analyticsContextData,
      sku,
      productDetails: state.products.productDetailsBySku[sku],
      isLoggedIn: isUserLoggedIn(state.user),
      isUpdating: basketItem && basketItem.isUpdating,
      loggedOutBasket: state.user.betaFeatures.includes('LOGGED_OUT_BASKET'),
      quantity: (!hideControls && basketItem && basketItem.quantity) || 0,
      warnings: get(state, `basket.productWarningsMessages[${product.sku}]`, {}),
      betaFeatures: state.user.betaFeatures,
    };
  },
)(BasketControls);
